export const dataAnalyticsTitlesAndPath = {
  ACTIVE_TUTORS: 'active-tutors',
  TRAINER_UNMAPPED: 'trainer-unmapped',
  NEWLY_ASSIGNED_TUTORS: 'newly-assigned-tutors',
  ACTIVE_TUTORS_SUBJECT: 'active-tutors-by-subject',
  TP_PAID_TUTORS: 'tp-paid-tutors',
  STUDENT_TUTOR_RATIO: 'student-tutor-ratio',
  TUTOR_CHANGE_DATA: 'tutor-change-data',
  INACTIVE_TUTORS: 'inactive-tutors',
  LAST_ASSIGNED_TP: 'last-assigned-tp',
  RESIGNED_TUTORS: 'resigned-tutors',
  COURSE_ENROLLMENT: 'course-enrollment',
  ACTIVE_STUDENTS: 'active-students',
};
